
<div class="vz-wiki-root layout vertical flex" [class.vz-mobile]="_mobile()">

    <!-- @if (newVersionReady && !newVersionHidden) {
        <div class="vz-new-version-panel layout center-center" [@removeH]>
            <div class="vz-nvp-icon layout vertical">
                <i class="vzi-info"></i>
            </div>
            <div class="vz-nvp-text layout center gap05 wrap">
                <div class="layout flex" [class.fs-s]="_mobile()">Доступна новая версия приложения. Перезагрузите страницу для продолжения работы.</div>
                <button nz-button nzType="primary" (click)="reload()">Перезагрузить</button>
                <button nz-button nzType="dashed" (click)="newVersionHidden = true">Позже</button>
            </div>
        </div>
    } -->

    <div class="layout flex relative">
        <router-outlet />
    </div>

</div>

<router-outlet name="g" />
